import types from "../types";

export const toggletheme = (theme) => ({
  type: types.themeTypes.TOGGLE_DARK_MODE,
  payload: theme,
});
